export default {
  apiEndpoint: 'http://localhost:3001/api/',
  sentryReleasePrefix: '',
  skipNotifications: 'false'
};
